import { Heading } from '@veracity/vui'
import styled from 'styled-components'

export const TextLogo = styled(Heading)`
  font-size: 18px;
`
